import { initI18N } from '@config/i18n';
import { APP_ENVIRONMENT } from '@constants/env';
import { store } from '@store/store';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { Main } from './Main';

initI18N();

export const App: React.FC = () => {
  // Disable console logging in production and staging
  if (!['development', 'local'].includes(APP_ENVIRONMENT)) {
    console.log = () => {};
    console.debug = () => {};
    console.error = () => {};
    console.info = () => {};
  }

  return (
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <Main />
        </BrowserRouter>
      </React.StrictMode>
    </Provider>
  );
};
